import { useMemo } from 'react';

export const useStandingsAcotations = standings => {
  const acotations = useMemo(
    () =>
      standings?.columns?.standings.filter(
        acotation =>
          acotation?.key !== 'team.name' && acotation?.key !== 'rank',
      ) || [],
    [standings?.columns?.standings],
  );

  return useMemo(
    () => {
      const leftColumnLength = Math.ceil(acotations.length / 2);

      return [
        acotations.slice(0, leftColumnLength),
        acotations.slice(leftColumnLength),
      ];
    },
    [acotations],
  );
};
